  <div class="row">
    <div class="col-12">
      <h1>Document Transfer</h1>
    </div>
    <div class="col-12 my-3">
      <a href="javascript:void(0)" routerLink="/conversions/resident-doc-move/start" class="btn btn-primary">Transfer Documents</a>
    </div>
    <div class="col-12">
      <h3>Document Transfer History
        <div>
          <small>(Showing sessions for the past 120 days)</small>
        </div>
        <div>
          <small>Today's date: {{ todaysDate | date: 'MM/dd/yyyy' }}</small>
        </div>
      </h3>
    </div>
  </div>

  <div id="documentTransfers">

    <div class="row">
      <div class="col-12">
        <table class="table table-bordered table-striped table-fit">
          <thead>
            <tr>
              <th scope="col">Session</th>
              <th scope="col" class="fit">Move Date/Time</th>
              <th scope="col">Moved By</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ds of _sessionsArray">
              <td><a href="javascript:" (click)="routeToDetailsPage(ds.k, ds.m)">{{ds.k}}</a></td>
              <td>{{ds.m.movedDateTime | date:'medium'}}</td>
              <td>{{ds.m.movedBy}}</td>
              <td>{{ds.m.status}}
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>


  </div>
